<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("reports.dataScientist") }}</h2>
      </div>
      <v-card elevation="0" class="px-5">
        <v-card-text>
          <div class="d-flex">
            <v-select
              :items="countries"
              item-text="name"
              item-value="id"
              dense
              outlined
              class="mr-2 wdt"
              v-model="countary"
              :placeholder="$t('reports.filterByCountry')"
            ></v-select>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByRegion')"
            ></v-select>
            <v-autocomplete
              v-model="farm"
              :items="farmsList"
              item-text="name"
              item-value="farmNumber"
              dense
              :loading="farmLoading"
              :search-input.sync="farmSearch"
              outlined
              v-on:change="getProductByCat"
              hide-no-data
              :placeholder="$t('reports.filterByFarm')"
              class="mr-2 wdt"
            ></v-autocomplete>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByTrait')"
            ></v-select>
            <v-select
              :items="regions"
              item-text="name"
              item-value="roleNumber"
              dense
              outlined
              class="mr-2 wdt"
              v-model="region"
              :placeholder="$t('reports.filterByYear')"
            ></v-select>
          </div>
          <!-- chips -->
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="6">
              <v-card class="mx-auto border rounded-lg" height="120" outlined>
                <v-list-item class="text-end">
                  <v-list-item-content class="mr-n4">
                    <v-list-item-title class="mt-n3">
                      <v-avatar size="15" color="#DAE1EC"></v-avatar>
                      <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn dark icon v-bind="attrs" v-on="on">
                            <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                      </v-menu>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item three-line class="mt-n11">
                  <!-- <v-list-item-avatar
                    size="70"
                    color="#DAE1EC"
                  ></v-list-item-avatar> -->
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-h5 subtitle-2 font-weight-black"
                    >
                      {{ $t("reports.avgBreedingValue") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-6 font-weight-medium">
                      <div class="d-flex flex-row">
                        <v-progress-linear value="85"></v-progress-linear
                        ><span class="ml-9">85%</span>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-card
                class="mx-auto border rounded-lg ml-5"
                height="120"
                outlined
              >
                <v-list-item class="text-end">
                  <v-list-item-content class="mr-n4">
                    <v-list-item-title class="mt-n3">
                      <v-avatar size="15" color="#DAE1EC"></v-avatar>
                      <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn dark icon v-bind="attrs" v-on="on">
                            <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                      </v-menu>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item three-line class="mt-n11">
                  <!-- <v-list-item-avatar
                    size="70"
                    color="#DAE1EC"
                  ></v-list-item-avatar> -->
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-h5 subtitle-2 font-weight-black"
                    >
                      {{ $t("reports.avgEconomicIndex") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-6 font-weight-medium">
                      <div class="d-flex flex-row">
                        <v-progress-linear value="71"></v-progress-linear
                        ><span class="ml-9">71%</span>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="12">
              <v-card
                class="mx-auto border rounded-lg mx-9 mt-5"
                elevation="0"
                outlined
              >
                <template>
                  <div class="d-flex my-5">
                    <p class="mt-2 ml-4">{{ $t("animal.conception") }}</p>
                    <v-spacer></v-spacer>
                    <div class="py-1 title">
                      {{ fromConception }} - {{ toConception }} of
                      {{ totalConception }}
                    </div>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      :disabled="tableOptionsConception.page <= 1"
                      @click="pageChangeConception(false)"
                    >
                      <v-icon dark> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      :disabled="
                        tableOptionsConception.page >= totalPagesConception
                      "
                      @click="pageChangeConception(true)"
                    >
                      <v-icon dark> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      @click="exportConception"
                    >
                      <v-icon dark> mdi-export </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      @click="
                        printPDF($refs.conception, 'Conception(Data Scientist)')
                      "
                    >
                      <v-icon dark> mdi-printer </v-icon>
                    </v-btn>
                  </div>
                </template>
                <div ref="conception">
                  <v-data-table
                    :headers="headersForConception"
                    :items="itemsForConception"
                    :items-per-page="5"
                    :loading="conceptionLoading"
                    hide-default-footer
                    :options.sync="tableOptionsConception"
                  >
                    <template v-slot:progress>
                      <v-progress-linear
                        color="primary"
                        :height="8"
                        indeterminate
                      ></v-progress-linear>
                    </template>

                    <!-- <template v-slot:[`item.conceptionMethod`]="{ item }">
                    {{ item.conceptionMethod.name }}
                  </template> -->
                  </v-data-table>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="12">
              <v-card
                class="mx-auto border rounded-lg mx-9 mt-5"
                elevation="0"
                outlined
              >
                <template>
                  <div class="d-flex my-5">
                    <p class="mt-2 ml-4">{{ $t("dashboardS.performanceOfGeno") }}</p>
                    <v-spacer></v-spacer>
                    <div class="py-1 title">
                      {{ fromGenotype }} - {{ toGenotype }} of
                      {{ totalgenos }}
                    </div>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      :disabled="tableOptionsGenotype.page <= 1"
                      @click="pageChangeGenoType(false)"
                    >
                      <v-icon dark> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      :disabled="
                        tableOptionsGenotype.page >= totalPagesGenotype
                      "
                      @click="pageChangeGenoType(true)"
                    >
                      <v-icon dark> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      @click="exportGeno"
                    >
                      <v-icon dark> mdi-export </v-icon>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      fab
                      small
                      outlined
                      color="primary"
                      @click="
                        printPDF(
                          $refs.geno,
                          'Performance of Genotype(Data Scientist)'
                        )
                      "
                    >
                      <v-icon dark> mdi-printer </v-icon>
                    </v-btn>
                  </div>
                </template>
                <div ref="geno">
                  <v-data-table
                    :headers="headersForGenotype"
                    :items="itemsForGenotype"
                    :items-per-page="5"
                    :loading="genoLoading"
                    hide-default-footer
                    :options.sync="tableOptionsGenotype"
                    :server-items-length="totalgenos"
                  >
                    <template v-slot:progress>
                      <v-progress-linear
                        color="primary"
                        :height="8"
                        indeterminate
                      ></v-progress-linear>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import FarmService from "@/_services/farmService.js";
import Breadcrumb from "@/components/core/Breadcrumb";
import ProductService from "@/_services/ReportingService.js";
import loadingMixin from "@/mixins/LoadingMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
export default {
  components: {
    breadcrumb: Breadcrumb,
  },
  mounted() {
    document.title = this.$t('reports.analyticsAndReporting');
    this.searchFarm(this.farm);
  },
  watch: {
    async farmSearch(val) {
      await this.searchFarm(val);
    },
    tableOptionsConception: {
      handler() {
        this.getConception();
      },
      deep: true,
    },
    tableOptionsGenotype: {
      handler() {
        this.getGenoType();
      },
      deep: true,
    },
  },
  data() {
    return {
      countries: [],
      regions: [],
      countary: null,
      conceptionLoading: false,
      region: null,
      farmsList: [],
      farmLoading: false,
      farmSearch: "",
      search: "",
      farm: "FRM000011018186",
      genoLoading: false,
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('reports.analyticsAndReporting'),
          disabled: true,
        },
        {
          text: this.$t('reports.dataScientistReport'),
          disabled: true,
        },
      ],

      headersForConception: [
        { text: this.$t('actionListmod.inseminatorId'), sortable: false, value: "inseminatorNumber" },
        { text: this.$t('actionListmod.inseminatorName'), sortable: false, value: "inseminatorName" },
        { text: this.$t('actionListmod.conceptionRate'), sortable: false, value: "conceptionRate" },
        { text: this.$t('lastUpdated'), sortable: false, value: "updatedAt" },
      ],
      itemsForConception: [],

      headersForGenotype: [
        { text: this.$t('animal.breed'), sortable: false, value: "breed.breedName" },
        { text: this.$t('dashboardS.chromosome'), sortable: false, value: "chromosome" },
        { text: this.$t('dashboardS.seqChange'), sortable: false, value: "sequenceChange" },
        { text: this.$t('dashboardS.inheritance'), sortable: false, value: "inheritance" },
        { text: this.$t('dashboardS.diseaseName'), sortable: false, value: "diseaseName" },
        {
          text: this.$t('dashboardS.refSequence'),
          sortable: false,
          value: "referenceSequence",
        },
        { text: this.$t('dashboardS.pubmedRef'), sortable: false, value: "pubmedReference" },
      ],
      itemsForGenotype: [
        {
          breedName: "Senepol",
          chromosome: 20,
          sequenceChange: "g.39099226C>A",
          inheritance: "Dominant",
          diseaseName: "Slick Hair",
          referenceSequence: "ARS-UCD1.2",
          pubmedReference: "29527221",
        },
        {
          breedName: "Poll Hereford",
          chromosome: 7,
          sequenceChange: "g.65080197C>A",
          inheritance: "Recessive",
          diseaseName: "Myoclonus",
          referenceSequence: "Bos_taurus_UMD_3.1",
          pubmedReference: "11178872",
        },
      ],

      tableOptionsConception: {},
      fromConception: 0,
      toConception: 0,
      totalConception: 1,
      totalPagesConception: 1,

      tableOptionsGenotype: {
        page: 1,
        itemsPerPage: 5,
      },
      fromGenotype: 0,
      toGenotype: 0,
      totalgenos: 1,
      totalPagesGenotype: 1,
    }
  },
  methods: {
    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then((res) => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },
    exportConception() {
      html2pdf(this.$refs.conception, {
        margin: 1,
        filename: "Conception Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportGeno() {
      html2pdf(this.$refs.geno, {
        margin: 1,
        filename: "Geno Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getConception() {
      // this.startLoading()
      this.conceptionLoading = true;
      ProductService.getdataConception(this.tableOptionsConception, this.farm)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForConception = res.data.inseminationData.rows;
            this.currentrows = res.data.inseminationData.num_rows;
            this.totalConception = res.data.inseminationData.total_rows;
            this.pageCount = Math.ceil(
              this.totalConception / this.tableOptionsConception.itemsPerPage
            );
            this.totalPagesConception = Math.ceil(
              this.totalConception / this.tableOptionsConception.itemsPerPage
            );
            this.fromConception =
              (this.tableOptionsConception.page - 1) *
                this.tableOptionsConception.itemsPerPage +
              1;
            this.toConception =
              this.tableOptionsConception.page *
                this.tableOptionsConception.itemsPerPage -
              (this.tableOptionsConception.itemsPerPage -
                res.data.inseminationData.num_rows);
            this.conceptionLoading = false;
            // this.stopLoading()
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeConception(t) {
      if (t)
        this.tableOptionsConception.page = this.tableOptionsConception.page + 1;
      else
        this.tableOptionsConception.page = this.tableOptionsConception.page - 1;

      this.getConception();
    },
    getGenoType() {
      this.genoLoading = true;
      ProductService.getdatageno(this.tableOptionsGenotype, this.farm)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForGenotype = res.data.geoTypePerformanceData.rows;
            this.currentrows = res.data.geoTypePerformanceData.num_rows;
            this.totalgenos = res.data.geoTypePerformanceData.total_rows;
            this.pageCount = Math.ceil(
              this.totalgenos / this.tableOptionsGenotype.itemsPerPage
            );
            this.totalPagesGenotype = Math.ceil(
              this.totalgenos / this.tableOptionsGenotype.itemsPerPage
            );
            console.log(this.totalPagesGenotype);
            this.fromGenotype =
              (this.tableOptionsGenotype.page - 1) *
                this.tableOptionsGenotype.itemsPerPage +
              1;
            this.toGenotype =
              this.tableOptionsGenotype.page *
                this.tableOptionsGenotype.itemsPerPage -
              (this.tableOptionsGenotype.itemsPerPage -
                res.data.geoTypePerformanceData.num_rows);
            console.log(this.toGenotype);
            this.genoLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeGenoType(t) {
      if (t)
        this.tableOptionsGenotype.page = this.tableOptionsGenotype.page + 1;
      else this.tableOptionsGenotype.page = this.tableOptionsGenotype.page - 1;

      this.getGenoType();
    },
    async getProductByCat() {
      console.log(this.farm);
      await this.getConception();
      await this.getGenoType();
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
</style>
